import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Toggle as TogglePrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

const toggleVariants = cva(
  'tw:hover:text-foreground tw:aria-pressed:bg-muted tw:data-[state=on]:bg-muted tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive tw:gap-1 tw:rounded-lg tw:text-sm tw:font-medium tw:transition-all tw:[&_svg:not([class*=size-])]:size-4 tw:group/toggle tw:hover:bg-muted tw:inline-flex tw:items-center tw:justify-center tw:whitespace-nowrap tw:outline-none tw:focus-visible:ring-[3px] tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:[&_svg]:pointer-events-none tw:[&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'tw:bg-transparent',
        outline:
          'tw:border-input tw:hover:bg-muted tw:border tw:bg-transparent',
      },
      size: {
        default: 'tw:h-8 tw:min-w-8 tw:px-2',
        sm: 'tw:h-7 tw:min-w-7 tw:rounded-[min(var(--radius-md),12px)] tw:px-1.5 tw:text-[0.8rem] tw:[&_svg:not([class*=size-])]:size-3.5',
        lg: 'tw:h-9 tw:min-w-9 tw:px-2.5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

function Toggle({
  className,
  variant = 'default',
  size = 'default',
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Toggle, toggleVariants };
